let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9bNeM")).then(() => parcelRequire('iy5Tj'));